import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "reporting-themes" }
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = {
  key: 1,
  class: "themes"
}

import { computed, watch, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { GET_PROJECT_WITH_BUDGET_AND_THEMES } from "@/graphql/project/queries";
import {
  type ProjectWithBudgetAndThemes,
  ThemeProjectWithBudget,
} from "@/helpers/project/typesDefinition";
import { useI18n } from "vue-i18n";
import ThemeBudget from "@/components/ThemeBudget.vue";
import ButtonContactAdmin from "@/components/ButtonContactAdmin.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectReportingThematic',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const queryVariables = computed(() => {
  return { id: props.id, withInactiveThemes: true };
});
const {
  result,
  loading: hasLoaded,
  error,
} = useQuery<{ project: ProjectWithBudgetAndThemes }>(
  GET_PROJECT_WITH_BUDGET_AND_THEMES,
  queryVariables,
);

const loading = computed(() => !hasLoaded && t("loading"));

const project = computed(() => {
  return result.value?.project;
});

const globalConsumption = computed(() => {
  return themes.value.reduce((acc: number, theme: ThemeProjectWithBudget) => {
    return acc + theme.performedAmount;
  }, 0);
});

const globalBudget = ref();
const themes = ref();

watch(project, () => {
  const budget = project.value?.budget;
  if (!budget) {
    themes.value = project.value?.themes;
  } else {
    globalBudget.value = project.value.budget.amount;
    themes.value = project.value?.themes.map((theme) => {
      const currentTheme = budget.themes.find((t) => t.theme.id === theme.id);

      // TODO: Emiref
      //  E-maprod maintenance (active) budget != maintenance (inactive) timesheet
      //  Not sure how it happened ? to follow...
      if (currentTheme) {
        return {
          ...theme,
          budget: currentTheme?.amount,
          consumed: currentTheme?.theme.performedAmount,
        };
      } else
        return {
          ...theme,
          budget: 0,
          consumed: theme.performedAmount,
        };
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(error) && !loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (themes.value?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("project.budgetThemes.empty")), 1),
                _createVNode(ButtonContactAdmin)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themes.value, (theme) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: theme.id
                  }, [
                    (theme.consumed)
                      ? (_openBlock(), _createBlock(ThemeBudget, {
                          key: 0,
                          id: theme.id,
                          title: theme.name,
                          budget: theme.budget,
                          globalBudget: globalBudget.value,
                          consumed: theme.consumed,
                          "global-consumed": globalConsumption.value
                        }, null, 8, ["id", "title", "budget", "globalBudget", "consumed", "global-consumed"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})